"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _deserialize = _interopRequireDefault(require("./deserialize"));
var _render = _interopRequireDefault(require("./render"));
var ParagraphPlugin = function ParagraphPlugin(options) {
  return {
    renderElement: (0, _render["default"])(options),
    deserialize: (0, _deserialize["default"])(options)
  };
};
var _default = exports["default"] = ParagraphPlugin;